import { c as _c } from "react/compiler-runtime";
import EmailStatisticsEmailFilter from 'modules/mailing/email-statistics/components/email-statistics-email-filter';
import { EmailStatisticsStatusFilter } from 'modules/mailing/email-statistics/components/email-statistics-status-filter';
import { emailClickLinkStatisticsTableColumns } from 'modules/mailing/email-statistics/configs/email-click-link-statistics-table-columns';
import { emailStatisticsTableColumns } from 'modules/mailing/email-statistics/configs/email-statistics-table-columns';
import { useEmailClickLinkStatistics } from 'modules/mailing/email-statistics/hooks/use-email-click-link-statistics';
import { useEmailStatistics } from 'modules/mailing/email-statistics/hooks/use-email-statistics';
import { StatisticsFilterApiInterface, StatisticsFilterInterface } from 'modules/mailing/email-statistics/types/email-statistics-filter-interface';
import { MailingId } from 'modules/mailing/types/mailing-interface';
import React, { useCallback, useEffect, useState } from 'react';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { useFilterWithAbort } from 'shared/hooks/use-filter-with-abort';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { useFilterPagination } from 'shared/route-query/hooks/use-filter-pagination';
import { OrderEnum } from 'shared/types/pagination-interface';
import { deepCompare } from 'shared/utils/deepCompare';
interface MailingStatisticProps {
  mailingId: MailingId;
  isAdminPage?: boolean;
}
const defaultFilters: StatisticsFilterInterface = {
  contacts: [],
  opened: undefined,
  clicked: undefined,
  spam: undefined,
  bounced: undefined
};
export function MailingStatistic(t0) {
  const $ = _c(101);
  const {
    mailingId,
    isAdminPage
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const {
    setPagination,
    pagination,
    setLimit,
    limit,
    filter,
    setFilter
  } = useFilterPagination(defaultFilters);
  const [responsiveFilter, setResponsiveFilter] = useState(defaultFilters);
  let t1;
  let t2;
  if ($[0] !== filter) {
    t1 = () => {
      setResponsiveFilter(filter);
    };
    t2 = [filter];
    $[0] = filter;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = filter.bounced;
  const t4 = filter.clicked;
  const t5 = filter.opened;
  const t6 = filter.spam;
  let t7;
  if ($[3] !== filter.contacts) {
    t7 = filter.contacts.map(_temp);
    $[3] = filter.contacts;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== filter.bounced || $[6] !== filter.clicked || $[7] !== filter.opened || $[8] !== filter.spam || $[9] !== t7) {
    t8 = {
      bounced: t3,
      clicked: t4,
      opened: t5,
      spam: t6,
      contactIds: t7
    };
    $[5] = filter.bounced;
    $[6] = filter.clicked;
    $[7] = filter.opened;
    $[8] = filter.spam;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const apiFilter = t8;
  let t9;
  if ($[11] !== apiFilter || $[12] !== limit || $[13] !== mailingId || $[14] !== pagination) {
    t9 = {
      emailId: mailingId,
      limit,
      pagination,
      filter: apiFilter
    };
    $[11] = apiFilter;
    $[12] = limit;
    $[13] = mailingId;
    $[14] = pagination;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const {
    statistics,
    counter,
    isStatisticsValidating,
    abortStatistics
  } = useEmailStatistics(t9);
  let t10;
  if ($[16] !== responsiveFilter || $[17] !== setFilter || $[18] !== setLimit || $[19] !== setPagination) {
    t10 = () => {
      setFilter(responsiveFilter);
      setPagination({
        order: OrderEnum.next
      });
      setLimit(10);
    };
    $[16] = responsiveFilter;
    $[17] = setFilter;
    $[18] = setLimit;
    $[19] = setPagination;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const handleFilter = t10;
  let t11;
  if ($[21] !== filter || $[22] !== responsiveFilter) {
    t11 = deepCompare(filter, responsiveFilter);
    $[21] = filter;
    $[22] = responsiveFilter;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const t12 = !t11;
  let t13;
  if ($[24] !== abortStatistics || $[25] !== handleFilter || $[26] !== t12) {
    t13 = {
      handleFilter,
      onAbort: abortStatistics,
      shouldUpdate: t12
    };
    $[24] = abortStatistics;
    $[25] = handleFilter;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  useFilterWithAbort(t13);
  let t14;
  if ($[28] !== mailingId) {
    t14 = {
      mailingId
    };
    $[28] = mailingId;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  const {
    data: emailClickLinkStatistics
  } = useEmailClickLinkStatistics(t14);
  let T0;
  let T1;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t21;
  let t22;
  if ($[30] !== counter || $[31] !== emailClickLinkStatistics || $[32] !== isAdminPage || $[33] !== isStatisticsValidating || $[34] !== limit || $[35] !== mailingId || $[36] !== pagination || $[37] !== responsiveFilter || $[38] !== setLimit || $[39] !== setPagination || $[40] !== statistics || $[41] !== t || $[42] !== user) {
    const totalClicksForTheEmail = emailClickLinkStatistics?.items.reduce(_temp2, 0) ?? 0;
    t21 = "flex flex-col gap-5";
    const t23 = isStatisticsValidating ? undefined : statistics;
    let t24;
    if ($[53] !== t) {
      t24 = t("dashboard.email_statistics.table.title");
      $[53] = t;
      $[54] = t24;
    } else {
      t24 = $[54];
    }
    let t25;
    if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
      t25 = contacts => setResponsiveFilter(prev => ({
        ...prev,
        contacts
      }));
      $[55] = t25;
    } else {
      t25 = $[55];
    }
    let t26;
    if ($[56] !== responsiveFilter.contacts) {
      t26 = <EmailStatisticsEmailFilter contacts={responsiveFilter.contacts} onChangeContacts={t25} />;
      $[56] = responsiveFilter.contacts;
      $[57] = t26;
    } else {
      t26 = $[57];
    }
    let t27;
    if ($[58] !== responsiveFilter) {
      t27 = <EmailStatisticsStatusFilter setFilter={setResponsiveFilter} filter={responsiveFilter} />;
      $[58] = responsiveFilter;
      $[59] = t27;
    } else {
      t27 = $[59];
    }
    let t28;
    if ($[60] !== t26 || $[61] !== t27) {
      t28 = <div className="flex flex-wrap-reverse items-center gap-3">{t26}{t27}</div>;
      $[60] = t26;
      $[61] = t27;
      $[62] = t28;
    } else {
      t28 = $[62];
    }
    const t29 = isStatisticsValidating ? undefined : statistics;
    let t30;
    if ($[63] !== isAdminPage || $[64] !== t || $[65] !== user) {
      t30 = emailStatisticsTableColumns({
        disableEmailLink: isAdminPage,
        user,
        t
      });
      $[63] = isAdminPage;
      $[64] = t;
      $[65] = user;
      $[66] = t30;
    } else {
      t30 = $[66];
    }
    let t31;
    if ($[67] !== limit || $[68] !== setLimit) {
      t31 = {
        limit,
        setLimit
      };
      $[67] = limit;
      $[68] = setLimit;
      $[69] = t31;
    } else {
      t31 = $[69];
    }
    let t32;
    if ($[70] !== pagination || $[71] !== setPagination) {
      t32 = {
        pagination,
        setPagination
      };
      $[70] = pagination;
      $[71] = setPagination;
      $[72] = t32;
    } else {
      t32 = $[72];
    }
    let t33;
    if ($[73] !== t29 || $[74] !== t30 || $[75] !== t31 || $[76] !== t32) {
      t33 = <Table data={t29} columns={t30} limiter={t31} paginator={t32} />;
      $[73] = t29;
      $[74] = t30;
      $[75] = t31;
      $[76] = t32;
      $[77] = t33;
    } else {
      t33 = $[77];
    }
    if ($[78] !== counter || $[79] !== t23 || $[80] !== t24 || $[81] !== t28 || $[82] !== t33) {
      t22 = <ListingLayout counter={counter} data={t23} title={t24} type="default" headerClassName="flex-wrap" customHeaderElement={t28}>{t33}</ListingLayout>;
      $[78] = counter;
      $[79] = t23;
      $[80] = t24;
      $[81] = t28;
      $[82] = t33;
      $[83] = t22;
    } else {
      t22 = $[83];
    }
    T1 = ListingLayout;
    t17 = false;
    t18 = emailClickLinkStatistics;
    if ($[84] !== t) {
      t19 = t("dashboard.email_statistics.table_links.title");
      $[84] = t;
      $[85] = t19;
    } else {
      t19 = $[85];
    }
    t20 = "default";
    T0 = Table;
    t15 = emailClickLinkStatistics;
    t16 = emailClickLinkStatisticsTableColumns({
      t,
      totalClicksForTheEmail,
      mailingId
    });
    $[30] = counter;
    $[31] = emailClickLinkStatistics;
    $[32] = isAdminPage;
    $[33] = isStatisticsValidating;
    $[34] = limit;
    $[35] = mailingId;
    $[36] = pagination;
    $[37] = responsiveFilter;
    $[38] = setLimit;
    $[39] = setPagination;
    $[40] = statistics;
    $[41] = t;
    $[42] = user;
    $[43] = T0;
    $[44] = T1;
    $[45] = t15;
    $[46] = t16;
    $[47] = t17;
    $[48] = t18;
    $[49] = t19;
    $[50] = t20;
    $[51] = t21;
    $[52] = t22;
  } else {
    T0 = $[43];
    T1 = $[44];
    t15 = $[45];
    t16 = $[46];
    t17 = $[47];
    t18 = $[48];
    t19 = $[49];
    t20 = $[50];
    t21 = $[51];
    t22 = $[52];
  }
  let t23;
  if ($[86] !== T0 || $[87] !== t15 || $[88] !== t16) {
    t23 = <T0 data={t15} columns={t16} paginationIdField="link" />;
    $[86] = T0;
    $[87] = t15;
    $[88] = t16;
    $[89] = t23;
  } else {
    t23 = $[89];
  }
  let t24;
  if ($[90] !== T1 || $[91] !== t17 || $[92] !== t18 || $[93] !== t19 || $[94] !== t20 || $[95] !== t23) {
    t24 = <T1 counter={t17} data={t18} title={t19} type={t20}>{t23}</T1>;
    $[90] = T1;
    $[91] = t17;
    $[92] = t18;
    $[93] = t19;
    $[94] = t20;
    $[95] = t23;
    $[96] = t24;
  } else {
    t24 = $[96];
  }
  let t25;
  if ($[97] !== t21 || $[98] !== t22 || $[99] !== t24) {
    t25 = <div className={t21}>{t22}{t24}</div>;
    $[97] = t21;
    $[98] = t22;
    $[99] = t24;
    $[100] = t25;
  } else {
    t25 = $[100];
  }
  return t25;
}
function _temp2(acc, item) {
  return acc + item.totalClickAmount;
}
function _temp(el) {
  return el.id;
}